//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";
import _ from "lodash";
import moment from "moment";


function getQuarterOption(quarterMoment) {
	return {
		value : quarterMoment.format('YYYY - [Q]Q'),
		display : quarterMoment.format('YYYY - [Q]Q'),
	} ;
}

const quarterOptions = [];
_.range(4,0).forEach(i => {
	quarterOptions.push(
		getQuarterOption(moment().subtract(i, 'quarters'))
	);
});

quarterOptions.push(
	getQuarterOption(moment())
);

_.range(1,20).forEach(i => {
	quarterOptions.push(
		getQuarterOption(moment().add(i, 'quarters'))
	);
});

class FMPQuarterPicker extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md,
		} = this.props;

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={quarterOptions}
				onChange={onChange}
				md={md}
				helpText={helpText}
				contained={false}
			/>
		);
	}
}

FMPQuarterPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
};

FMPQuarterPicker.defaultProps =  {
	md : 12,
	label : 'Payment option select',
};

export default FMPQuarterPicker;